import * as io from "io-ts";
import { useCallback, useMemo } from "react";
import { useDashboardEditorContext } from "../../../../../../hook/context/editor";
import { useGUIEditorContext } from "../../../../../../hook/context/gui";
import createGlobalState from "@ui/lib/createGlobalState";

const useLayerRulePlotbandsState = createGlobalState({
  key: "editorLayerRulePlotbands",
  storage: "local",
  type: io.boolean,
  scoped: true,
});

export function useLayerRulePlotbands() {
  const editor = useDashboardEditorContext();
  const { block } = useGUIEditorContext();
  const [value, setValue] = useLayerRulePlotbandsState({
    defaultValue: block?.config?.options?.showOvertakingPlotBands ?? false,
    scope: block?.id,
  });

  const updateOvertakingPlotbands = useCallback(
    (showOvertakingPlotBands: boolean) => {
      if (!block) return;
      setValue(showOvertakingPlotBands);
      void editor?.updateBlock({
        ...block,
        config: {
          ...block.config,
          options: {
            ...block.config.options,
            showOvertakingPlotBands,
          },
        },
      });
    },
    [block, editor, setValue],
  );

  return useMemo(
    () => ({
      value,
      updateOvertakingPlotbands,
    }),
    [updateOvertakingPlotbands, value],
  );
}
